import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-plus-dark',
  templateUrl: './icon-plus-dark.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPlusDarkComponent {}
